import { render, staticRenderFns } from "./MyQuestions.vue?vue&type=template&id=586dae52&"
import script from "./MyQuestions.vue?vue&type=script&lang=js&"
export * from "./MyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./MyQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyQuestions.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VList,
})
